import $ from "jquery"
import DropdownTemplateView from "../../DropdownTemplateView"
import WorkflowStatusSelector from '../../workflowStatus/components/WorkflowStatusSelector'
import {Feature, isEnabled} from '../../features/index'

export default class TaskStatusMenu extends DropdownTemplateView {
    constructor($containerEl, {
        showActionNames = false,
        showSelectedFirst = false,
        showMenuCb = () => {},
        hideMenuCb = () => {},
    } = {}) {
        super($containerEl)

        this.params = {
            showActionNames,
        }

        this.showMenuCb = showMenuCb
        this.hideMenuCb = hideMenuCb

        this.state = {
            showCompletedFirst: false,
            showReopenLabel: false,
        }

        this.onAnyStatePropertyChanged(['showCompletedFirst', 'showReopenLabel'], ({showCompletedFirst, showReopenLabel}) => {
            this.statusesSelector.setState({
                showCompletedFirst: showCompletedFirst,
                showReopenLabel: showReopenLabel,
            })
        })
    }

    templateHtml() {
        return "<div class='dropdownContainer taskStatusMenu'></div>"
    }

    afterRender() {
        this.statusesSelector = new WorkflowStatusSelector({
            onSelectStatus: (id) => {
                this._selectStatus(id)
            },
            groupByStatusType: isEnabled(Feature.TWS),
            showActionNames: this.params.showActionNames,
            showSelectedFirst: this.params.showSelectedFirst,
        }).init(this.$el)

        this.getEl().on('click', e => e.stopPropagation())
    }

    update() {
        this.statusesSelector.update()
    }

    showAt($element, positionParams, callback) {
        super.showAt($element, positionParams);
        this.update();
        this.callback = callback;
    }

    onHide() {
        super.onHide()
        this.callback(this.statusId)
        this.hideMenuCb()
    }

    onShow() {
        super.onShow()
        this.showMenuCb()
    }

    setStatusId(id) {
        this.statusId = id
        this.statusesSelector.setState({
            selectedStatusId: id
        })
    }

    setInactiveOpenStatuses(inactiveOpenStatuses) {
        this.statusesSelector.setState({
            inactiveOpenStatuses
        })
    }

    _selectStatus(id) {
        this.setStatusId(id)
        this.hide()
    }

    mouseDownTargetElement() {
        return $('body')
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/task/TaskStatusMenu.js